<template>

<div class="row">
  <div class="col-lg-12">
    <div class="widget">
      <div class="row vertical-align align-items-center">
        <button
          type="button"
          class="btn btn-circle btn-lg btn-primary mr-2"
        >
          <i class="fa fa-chart-line" />
        </button>
          <h4>{{ $t('frotix_management') }}</h4>
      </div>
    </div>

    <ul
      class="list-group bg-white"
      v-for="(item, index) in frotix_management" :key="index"
    >
      <router-link :to='`${item.path}`'>
        <li class="list-group-item text-secondary">
          <h5 class="my-1">{{ $t(item.text) }}</h5>
        </li>
      </router-link>
    </ul>
  </div>
</div>
</template>

<script>
import { frotixManagement } from '@/config/settings'

export default {
  name: 'FrotixManagementList',
  data: () => ({
    frotix_management: []
  }),

  mounted () {
    const items = frotixManagement()

    for (const item of items) {
      this[item.type].push(item)
    }
  },
}
</script>
